import React, {useRef} from 'react';
import {MutationCache, QueryCache, QueryClient, QueryClientProvider} from 'react-query';
import {Toast} from 'primereact/toast';

let globalToast = null;

export const showToast = (severity, summary, detail, life = 5000) => {
    globalToast?.current?.show({severity, summary, detail, life});
};

export function ReactQueryProvider({children}) {
    const toastRef = useRef(null);
    globalToast = toastRef;

    const queryClient = new QueryClient({
        queryCache: new QueryCache({
            onError: (error, query) => {
                console.error(JSON.stringify(error));
            },
        }),
        mutationCache: new MutationCache({
            onError: (error, query) => {
                console.error(JSON.stringify(error));
            },
        }),
    });

    return (
        <QueryClientProvider client={queryClient}>
            <Toast ref={toastRef}/>
            {children}
        </QueryClientProvider>
    );
}